import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { RadioButton } from "primereact/radiobutton";
import { Tooltip } from "primereact/tooltip";
import { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useOutletContext } from "react-router-dom";
import PrimeConfirmDialog from "../../components/dialog/PrimeConfirmDialog";
import PrimeDialog from "../../components/dialog/PrimeDialog";
import ImageLocaleModal from "../../components/ImageLocaleModal";
import NoInfo from "../../components/NoInfo";
import PrimeTableFooter from "../../components/PrimeTableFooter";
import { useEditableFlag } from "../../hooks/useEditableFlag";
import { SystemLoading, checkLoading } from "../../store/loadingStore";
import { MessageContext, handleSuccessMessage } from "../../store/messageStore";
import { updateFeUsers2Info } from "../../utility/service/account-service";
import { AlertService } from "../../utility/service/alert-service";
import { handleFileDownloadRes } from "../../utility/service/api-base";
import { downloadMultipartFileReport, downloadMultipartFileWord } from "../../utility/service/api-file";
import {
  checkImportantIndetificationItem,
  createInventoryExportTask,
  createESGReport,
  deleteEsgReport,
  downloadInventoryExportTaskFile,
  esgReportList,
  queryInventoryExportTaskStatus,
  queryReportStatus,
} from "../../utility/service/carbon-service";
import { parseTabPermissions } from "../../utility/service/tab-permission-utils";
import { checkDpSuccess, getLocale } from "../../utility/service/tool-service";
import { AcctContext } from "../../utility/useReduce/userNameReduce";

export default function Carbon_Report() {
  const DEFAULT_EXPORT_MAX_RETRY = 120;
  const DEFAULT_EXPORT_INTERVAL_MS = 5000;
  const { t } = useTranslation();
  const isEditable = useEditableFlag("F10103"); // control edit by F10103
  const navigate = useNavigate();
  const {
    setAction,
    action,
    setItemObj,
    itemObj,
    reportListObj,
    flowStep,
    setFlowStep,
    companyName,
  } = useOutletContext();
  const [delDialog, setDelDialog] = useState(false);
  const [delObj, setDelObj] = useState({});
  const [delContent, setDelContent] = useState("");
  const [, dispatch] = useContext(MessageContext); //訊息視窗
  const [state, dispatchUser] = useContext(AcctContext); //訊息視窗
  //計時器 DGL0024
  const myInterval = useRef();
  const [isRunning, setIsRunning] = useState(false);
  // 分頁PK
  const [reportSeqPK, setReportSeqPK] = useState("");
  const [rows, setRows] = useState([]);
  const [createLoading, setCreateLoading] = useState(false);
  const [, loading] = useContext(SystemLoading);

  //展開table
  const [expandedRows, setExpandedRows] = useState(null);
  const [userState] = useContext(AcctContext);
  const effectiveType = userState?.effectiveType;

  // 流程圖模態框狀態
  const [flowCheck, setFlowCheck] = useState(false);
  const [flowModal, setFlowModal] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  // Tab 權限控制
  const [accessibleTabs, setAccessibleTabs] = useState([]);

  // 匯出清冊
  const [xlsxItemObj, setXlsxItemObj] = useState({});
  const [templateDialog, setTemplateDialog] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const exportPollingRef = useRef(null);
  // 重大性鑑別確認視窗
  const [importantDialog, setImportantDialog] = useState(false);

  // 載入 tab 權限
  useEffect(() => {
    const tabPermissions = state?.tabPermissions?.["F10103"];
    if (tabPermissions) {
      const parsedTabs = parseTabPermissions(tabPermissions);
      setAccessibleTabs(parsedTabs);
    } else {
      // 如果沒有權限設定，設為空陣列（無任何權限）
      setAccessibleTabs([]);
    }
  }, [state?.tabPermissions]);

  // 設置標記，表示從子頁面返回
  useEffect(() => {
    setFlowStep(6);
    sessionStorage.setItem("fromCarbonChildPage", "true");
    setFlowCheck(state?.dontShowAgain !== "N");
  }, []);

  const updateUserInfo = (dontShow) => {
    const value = dontShow ? "Y" : "N";
    if (value !== state?.dontShowAgain) {
      updateFeUsers2Info({
        userDataList: [
          {
            refKey: "DONT_SHOW_AGAIN",
            refValue: value,
          },
        ],
      }).then((res) => {
        dispatchUser({ type: "DONT_SHOW_AGAIN", payload: { dontShowAgain: value } });
      });
    }
  };

  const memoBodyTemplate = (data, props) => {
    return (
      <>
        <Tooltip target=".memoBody" />
        <span data-pr-tooltip={data?.memo} className="memoBody text-ellipsis">
          {data?.memo}
        </span>
      </>
    );
  };

  const versionNoTemplate = (data, props) => {
    if (data) {
      return (
        <span>
          {data?.version1}-{data?.version2}-{data?.version3}
        </span>
      );
    }
  };

  // 檢查特定 tab 是否有權限
  const hasTabPermission = (tabName) => {
    return accessibleTabs.includes(tabName);
  };

  const getCurrentLocale = () => {
    let _locale = "";
    if (getLocale()?.indexOf("-") > -1) {
      _locale = getLocale()?.split("-");
    } else {
      _locale = getLocale();
    }
    return Array.isArray(_locale) ? `${_locale[0]?.toLowerCase()}-${_locale[1]}` : _locale?.toLowerCase();
  };

  const actionAllBodyTemplate = (rowData, props) => {
    if (rowData) {
      return (
        <>
          <Button
            tooltip={t(`button.edit`)}
            tooltipOptions={{ position: "top" }}
            rounded
            text
            severity="secondary"
            className="p-button-icon-only"
            onClick={() => {
              editItem(rowData, true);
            }}
          >
            <FontAwesomeIcon icon="fa-solid fa-pen" />
          </Button>
          <Button
            tooltip={t(`button.download`)}
            tooltipOptions={{ position: "top" }}
            rounded
            text
            severity="secondary"
            className="p-button-icon-only"
            onClick={() => {
              downloadItem(rowData);
            }}
          >
            <FontAwesomeIcon icon="fa-solid fa-cloud-arrow-down" />
          </Button>

          {effectiveType === "0" && (
            <Button
              tooltip={t(`button.downloadWord`)}
              tooltipOptions={{ position: "top" }}
              rounded
              text
              severity="secondary"
              className="p-button-icon-only"
              onClick={() => {
                downloadWordItem(rowData);
              }}
            >
              <FontAwesomeIcon icon="fa-solid fa-file-word" />
            </Button>
          )}

          {rowData?.status === "X" && (
            <Button
              tooltipOptions={{ position: "top" }}
              rounded
              text
              severity="secondary"
              className="p-button-icon-only"
              onClick={() => {}}
            >
              <FontAwesomeIcon icon="fa-solid fa-triangle-exclamation" />
            </Button>
          )}
          <Button
            tooltip={t("button.delete")}
            tooltipOptions={{ position: "top" }}
            rounded
            text
            severity="secondary"
            className="p-button-icon-only"
            disabled={!isEditable}
            onClick={() => {
              deleteItem(rowData, "C");
            }}
          >
            <FontAwesomeIcon icon="fa-solid fa-trash" />
          </Button>
        </>
      );
    }
  };

  const actionBodyTemplate = (rowData, props) => {
    if (rowData) {
      return (
        <>
          {/* 不同狀態按鈕 status: P排程中 E可編輯, C完成 X錯誤 */}
          {rowData?.status === "P" && (
            <Button
              tooltip={t(`button.scheduled`)}
              tooltipOptions={{ position: "top" }}
              rounded
              text
              severity="secondary"
              className="p-button-icon-only"
              onClick={() => {}}
            >
              <FontAwesomeIcon icon="fa-solid fa-spinner" spin />
            </Button>
          )}
          {rowData?.status === "E" && (
            <>
              <Button
                tooltip={t(`button.edit`)}
                tooltipOptions={{ position: "top" }}
                rounded
                text
                severity="secondary"
                className="p-button-icon-only"
                onClick={() => {
                  editItem(rowData, false);
                }}
              >
                <FontAwesomeIcon icon="fa-solid fa-pen" />
              </Button>
              {/* 清冊按鈕 - 根據權限控制 */}
              {getCurrentLocale() === "zh-TW" && rowData?.inventoryVersion && rowData?.inventoryVersion !== "" && (
                <Button
                  tooltip={t("button.inventory")}
                  tooltipOptions={{ position: "top" }}
                  rounded
                  text
                  severity="secondary"
                  className="p-button-icon-only"
                  disabled={!hasTabPermission("inventory")}
                  onClick={() => {
                    handleExportItem(itemObj, rowData);
                    setXlsxItemObj(rowData);
                  }}
                >
                  <FontAwesomeIcon icon="fa-solid fa-file-export" />
                </Button>
              )}
            </>
          )}
          {rowData?.status === "C" && (
            <Button
              tooltip={t(`button.download`)}
              tooltipOptions={{ position: "top" }}
              rounded
              text
              severity="secondary"
              className="p-button-icon-only"
              onClick={() => {
                downloadItem(rowData);
              }}
            >
              <FontAwesomeIcon icon="fa-solid fa-cloud-arrow-down" />
            </Button>
          )}
          {rowData?.status === "X" && (
            <Button
              tooltipOptions={{ position: "top" }}
              rounded
              text
              severity="secondary"
              className="p-button-icon-only text-red-300"
              onClick={() => {}}
            >
              <FontAwesomeIcon icon="fa-solid fa-triangle-exclamation" />
            </Button>
          )}
          {rowData?.status !== "P" && (
            <Button
              tooltip={t("button.delete")}
              tooltipOptions={{ position: "top" }}
              rounded
              text
              severity="secondary"
              className="p-button-icon-only"
              disabled={!isEditable}
              onClick={() => {
                deleteItem(rowData, "E");
              }}
            >
              <FontAwesomeIcon icon="fa-solid fa-trash" />
            </Button>
          )}
        </>
      );
    }
  };

  const editItem = (rowData, isConfirm) => {
    setItemObj((pre) => {
      pre.version = rowData?.releaseList
        ? rowData.version1
        : rowData.version1 + "-" + rowData.version2 + "-" + rowData.version3;
      pre.fileId = rowData.fileId;
      pre.reportSeq = rowData.reportSeq;
      pre.isConfirm = isConfirm;
      return pre;
    });
    navigate("editfile");
  };

  const openPrintPreview = (htmlContent) => {
    const blob = new Blob([htmlContent], { type: "text/html" });
    const url = URL.createObjectURL(blob);

    // 新增一個iframe元素
    const iframe = document.createElement("iframe");
    iframe.id = "print-preview-frame";
    iframe.style.position = "absolute";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "none";
    document.body.appendChild(iframe);
    // iframe.src = url;

    // 將html 內容寫入 iframe
    iframe.contentWindow.document.open();
    iframe.contentWindow.document.write(htmlContent);
    iframe.contentWindow.document.close();
  };

  const downloadItem = (rowData) => {
    checkLoading(loading);
    downloadMultipartFileReport(
      {
        fileId: rowData?.fileId,
      },
      "text",
    )
      .then(async (res) => {
        if (res?.status === 200) {
          if (res.data) {
            if (typeof res.data === "string") {
              try {
                const jsonData = JSON.parse(res.data);

                AlertService.ok(jsonData?.ResHeader?.rtnMsg, "", "warning", jsonData?.ResHeader?.txId);
              } catch (error) {
                // const blob = new Blob([res.data], { type: 'text/html' });
                openPrintPreview(res.data);
              }
            }
          } else {
            console.error("Unexpected data format:", res.data);
          }
        } else {
          AlertService.ok(res?.data?.ResHeader?.rtnCode, res?.data?.ResHeader?.rtnMsg);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      })
      .finally((fin) => {
        checkLoading(loading, false);
      });
  };

  const downloadWordItem = async (rowData) => {
    try {
      checkLoading(loading);

      // 在 convert 成功後執行 word 下載，使用新的 fileId
      const downloadWord = async () => {
        const wordRes = await downloadMultipartFileWord(
          {
            fileId: rowData?.fileId,
          },
          "arraybuffer",
        );

        if (wordRes?.status === 200) {
          if (wordRes.data) {
            const buffer = wordRes.data;
            const contentType = wordRes.headers["content-type"] || "";

            // 嘗試將 buffer 轉換為文字
            let text = "";
            try {
              text = new TextDecoder("utf-8").decode(buffer);
              const jsonData = JSON.parse(text);

              if (jsonData?.ResHeader?.rtnCode === "1298") {
                // 等待 15 秒後重試
                await new Promise((resolve) => setTimeout(resolve, 15000));
                return await downloadWord();
              }
              // 只有在不是查無資料時才顯示提示
              if (jsonData?.ResHeader?.rtnCode !== "1298") {
                AlertService.ok(jsonData?.ResHeader?.rtnMsg, "", "warning", jsonData?.ResHeader?.txId);
              }
            } catch (error) {
              // 如果解析失敗，表示是二進位檔案
              const blob = new Blob([buffer], {
                type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
              });
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.download = `${rowData?.fileName}.docx`;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }
          } else {
            console.error("Unexpected data format:", wordRes.data);
          }
        } else {
          // 只有在不是查無資料時才顯示錯誤提示
          if (wordRes?.data?.ResHeader?.rtnCode !== "1298") {
            AlertService.ok(wordRes?.data?.ResHeader?.rtnCode, wordRes?.data?.ResHeader?.rtnMsg);
          }
        }
      };

      await downloadWord();
    } catch (error) {
      console.error("Error:", error);
      AlertService.ok("處理檔案時發生錯誤", "", "error");
    } finally {
      checkLoading(loading, false);
    }
  };

  const deleteItem = (rowData, layer) => {
    //layer C完成定版顯示version1-version2-version3 ; E 可編輯狀態 version1
    let versionStr =
      layer === "E" ? rowData?.version1 : `${rowData?.version1}-${rowData?.version2}-${rowData?.version3}`;
    setDelObj(rowData);
    setDelContent(`${t("versionNo")}: ${versionStr}`);
    setDelDialog(true);
  };

  const confirmDel = () => {
    //確認刪除
    let reqBody = {
      reportSeq: delObj.reportSeq,
    };
    checkLoading(loading);
    deleteEsgReport(reqBody)
      .then((res) => {
        if (checkDpSuccess(res)) {
          handleSuccessMessage(dispatch, t("button.delete") + " " + t("message.success"));
          let reqBody = {
            companySeq: itemObj?.companySeq,
            year: itemObj?.year,
            planSn: itemObj?.planSn,
          };
          axios_esgReportList(reqBody);
          setDelDialog(false);
        }
      })
      .finally(() => {
        checkLoading(loading, false);
      });
  };

  const btnReadMore = () => {
    let reqBody = {
      companySeq: itemObj?.companySeq,
      year: itemObj?.year,
      planSn: itemObj?.planSn,
      reportSeq: reportSeqPK,
    };
    axios_esgReportList(reqBody, true);
  };

  const isProgressTrace = (array) => {
    let progress = array?.filter((item) => item.status === "P");
    if (progress?.length > 0) {
      //裡面有排程中的資料
      setTimeout(() => {
        setIsRunning(true);
      }, 5000);
    } else {
      setIsRunning(false);
    }
  };

  const axios_esgReportList = (reqBody, isMore = false) => {
    checkLoading(loading);
    esgReportList(reqBody)
      .then((res) => {
        if (checkDpSuccess(res)) {
          let data = res.data.RespBody.reportList;
          if (data?.length > 0) {
            expandAll(data); //開啟全部子層
            setReportSeqPK(data[data?.length - 1].reportSeq);
            if (isMore === true) {
              //查看更多
              setRows((pre) => {
                const newRows = [...pre, ...data];
                isProgressTrace(newRows);
                return newRows;
              });
            } else {
              setRows(data);
              isProgressTrace(data);
            }
          } else {
            if (isMore === false) {
              setRows([]);
              setIsRunning(false);
            }
          }
        } else {
          if (isMore === false) {
            setRows([]);
            setIsRunning(false);
          }
        }
      })
      .finally((fin) => {
        checkLoading(loading, false);
      });
  };

   const getClassByCriterion = (criterion) => {
     if (criterion === "0") return "S";
     if (criterion === "9") return "G";
     return "C";
   };

  //產生報告書
  const axios_createESGReport = () => {
    setCreateLoading(true);
    checkLoading(loading);
    createESGReport({
      classType: getClassByCriterion(itemObj?.criterion),
      planList: reportListObj,
    })
      .then((res) => {
        if (checkDpSuccess(res)) {
          handleSuccessMessage(dispatch, t("button.create") + " " + t("message.success"));
          let reqBody = {
            companySeq: itemObj?.companySeq,
            year: itemObj?.year,
            planSn: itemObj?.planSn,
          };
          axios_esgReportList(reqBody);
        }
      })
      .finally((fin) => {
        setCreateLoading(false);
        checkLoading(loading, false);
      });
  };

  const transStatus = (status) => {
    let rpStatus = "";
    switch (status) {
      case "2":
        rpStatus = "P";
        break;
      case "3":
        rpStatus = "E";
        break;
      case "-1":
        rpStatus = "X";
        break;
    }
    return rpStatus;
  };

  const axios_queryReportStatus = (reqBody) => {
    queryReportStatus(reqBody).then((res) => {
      if (checkDpSuccess(res)) {
        let result = res.data.RespBody.reportList;
        if (result?.length > 0) {
          // 修改畫面上status
          setRows((prevList) =>
            prevList.map((item1) => {
              const matchingItem = result.find((item2) => item2.reportSeq === item1.reportSeq);
              if (matchingItem) {
                let matchStatus = transStatus(matchingItem.status);
                return {
                  ...item1,
                  status: matchStatus,
                  fileId: matchingItem.fileId,
                  memo: matchingItem.memo,
                  inventoryVersion: matchingItem.inventoryVersion,
                };
              }
              return item1;
            }),
          );

          let progress = result?.filter((item) => item.status === "2");
          if (progress?.length > 0) {
            setIsRunning(true);
          } else {
            setIsRunning(false);
          }
        }
      }
    });
  };

  useEffect(() => {
    if (JSON.stringify(itemObj) === "{}") {
      navigate("/management/carbonFootprint");
    } else {
      let reqBody = {
        companySeq: itemObj?.companySeq,
        year: itemObj?.year,
        planSn: itemObj?.planSn,
      };
      axios_esgReportList(reqBody);
    }

    return () => {
      if (myInterval.current !== null) {
        clearInterval(myInterval.current);
        myInterval.current = null;
      }
      if (exportPollingRef.current) {
        clearTimeout(exportPollingRef.current);
        exportPollingRef.current = null;
      }
    };
  }, []);

  const updateStatus = () => {
    const reportSeqList = rows?.filter((item) => item?.status === "P").map((seq) => seq.reportSeq);
    if (reportSeqList?.length > 0) {
      axios_queryReportStatus({ reportSeqList: reportSeqList });
    }
  };

  useEffect(() => {
    if (rows?.length > 0) {
      if (isRunning) {
        myInterval.current = setInterval(() => {
          updateStatus();
        }, 10000);
      } else {
        clearInterval(myInterval.current);
        myInterval.current = null;
      }
    }
  }, [isRunning]);

  //展開table
  const rowExpansionTemplate = (data) => {
    return (
      <div className="ml-8">
        <DataTable value={data?.releaseList} dataKey="reportSeq">
          <Column field="version1" header={t("versionNo")} body={versionNoTemplate} />
          <Column field="createUserName" header={t("createUser")} />
          <Column field="createDate" header={t("createDate")} />
          <Column field="updateUserName" header={t("editUser")} />
          <Column field="updateDate" header={t("editDate")} />
          <Column field="memo" body={memoBodyTemplate} header={t("remark")} />
          <Column
            style={{ width: "auto" }}
            body={actionAllBodyTemplate}
            header={t("action")}
            frozen
            alignFrozen="right"
          />
        </DataTable>
      </div>
    );
  };

  const allowExpansion = (rowData) => {
    return rowData?.releaseList?.length > 0;
  };

  const expandAll = (array) => {
    let _expandedRows = {};

    array.forEach((item) => {
      // 只处理第一层的 reportSeq
      if (item.releaseList && item.releaseList.length > 0) {
        _expandedRows[`${item.reportSeq}`] = true;
      }
    });

    setExpandedRows(_expandedRows);
  };

  const axios_checkImportantIndetificationItem = async (planSn) => {
    const res = await checkImportantIndetificationItem({ planSn });
    if (checkDpSuccess(res)) {
      let result = res?.data?.RespBody?.importanceList;
      return result?.length > 0; // 返回是否需要顯示對話框
    }
    return false;
  };

  const commonExportBodyTemplate = () => {
    return (
      <div className="flex flex-column gap-3">
        <div className="flex align-items-center">
          <RadioButton
            inputId="template1"
            name="template"
            value="template1"
            onChange={(e) => setSelectedTemplate(e.value)}
            checked={selectedTemplate === "template1"}
          />
          <label htmlFor="template1" className="ml-2">
            {t("溫室氣體盤查表單3.0.0版(修)")}
          </label>
        </div>
        <div className="flex align-items-center">
          <RadioButton
            inputId="template3"
            name="template"
            value="template3"
            onChange={(e) => setSelectedTemplate(e.value)}
            checked={selectedTemplate === "template3"}
          />
          <label htmlFor="template3" className="ml-2">
            {t("溫室氣體盤查表單3.0.0版(修)【含公式】")}
          </label>
        </div>
        <div className="flex align-items-center">
          <RadioButton
            inputId="template2"
            name="template"
            value="template2"
            onChange={(e) => setSelectedTemplate(e.value)}
            checked={selectedTemplate === "template2"}
          />
          <label htmlFor="template2" className="ml-2">
            {t("溫室氣體排放量清冊表單")}
          </label>
        </div>
        <div className="flex align-items-center">
          <RadioButton
            inputId="template4"
            name="template"
            value="template4"
            onChange={(e) => setSelectedTemplate(e.value)}
            checked={selectedTemplate === "template4"}
          />
          <label htmlFor="template4" className="ml-2">
            {t("溫室氣體排放量清冊表單【含公式】")}
          </label>
        </div>
      </div>
    );
  };

  const industrialExportBodyTemplate = (planTypeName) => {
    return (
      <div className="flex flex-column gap-3">
        <div className="flex align-items-center">
          <RadioButton
            inputId="template5"
            name="template"
            value="template5"
            onChange={(e) => setSelectedTemplate(e.value)}
            checked={selectedTemplate === "template5"}
          />
          <label htmlFor="template5" className="ml-2">
            {t(`${planTypeName ? `【${planTypeName}】` : ""}溫室氣體排放量清冊表單`)}
          </label>
        </div>
        <div className="flex align-items-center">
          <RadioButton
            inputId="template5_import"
            name="template"
            value="template5_import"
            onChange={(e) => setSelectedTemplate(e.value)}
            checked={selectedTemplate === "template5_import"}
          />
          <label htmlFor="template5_import" className="ml-2">
            {t(`${planTypeName ? `【${planTypeName}】` : ""}事業溫室氣體排放量資訊平台匯入表單`)}
          </label>
        </div>
      </div>
    );
  };

  const handleExportItem = (itemObj, rowData) => {
    // 若有重大性鑑別，先調用 API 檢查
    if (itemObj?.importanceIdentification === "Y") {
      axios_checkImportantIndetificationItem(itemObj?.planSn).then((showDialog) => {
        if (showDialog) {
          // 如果需要顯示對話框，則開啟對話框
          setImportantDialog(true);
        } else {
          setTemplateDialog(true);
        }
      });
    } else {
      setTemplateDialog(true);
    }
  };

  const stopExportPolling = () => {
    if (exportPollingRef.current) {
      clearTimeout(exportPollingRef.current);
      exportPollingRef.current = null;
    }
  };

  const closeExportingFlow = () => {
    stopExportPolling();
    checkLoading(loading, false);
  };

  const getExportFileName = () => {
    return `${itemObj?.planTypeName}_${itemObj?.year}_${itemObj?.displayCause}_${itemObj?.companyName}${
      itemObj?.placeName ? `_${itemObj?.placeName}` : ""
    }.xlsx`;
  };

  const resolveExportPollingConfig = (respBody) => {
    const maxRetry = Number(respBody?.pollingMaxRetry);
    const intervalSeconds = Number(respBody?.pollingIntervalSeconds);

    return {
      maxRetry: Number.isInteger(maxRetry) && maxRetry > 0 ? maxRetry : DEFAULT_EXPORT_MAX_RETRY,
      intervalMs:
        Number.isInteger(intervalSeconds) && intervalSeconds > 0 ? intervalSeconds * 1000 : DEFAULT_EXPORT_INTERVAL_MS,
    };
  };

  const downloadExportFile = (taskSeq) => {
    checkLoading(loading, true, t("inventoryExport.processing"));
    downloadInventoryExportTaskFile({ taskSeq })
      .then((res) => {
        if (res?.status === 200) {
          handleFileDownloadRes(res, getExportFileName());
        } else {
          AlertService.ok(res?.data?.ResHeader?.rtnCode, res?.data?.ResHeader?.rtnMsg);
        }
      })
      .finally(() => {
        closeExportingFlow();
      });
  };

  const pollExportStatus = (taskSeq, pollingConfig, retry = 0) => {
    if (retry > pollingConfig.maxRetry) {
      closeExportingFlow();
      AlertService.ok("TIMEOUT", t("inventoryExport.timeout"));
      return;
    }

    queryInventoryExportTaskStatus({ taskSeqList: [taskSeq] })
      .then((res) => {
        if (!checkDpSuccess(res)) {
          throw new Error("queryInventoryExportTaskStatus failed");
        }
        const result = res?.data?.RespBody?.taskList?.find((item) => item.taskSeq === taskSeq);
        if (!result) {
          exportPollingRef.current = setTimeout(
            () => pollExportStatus(taskSeq, pollingConfig, retry + 1),
            pollingConfig.intervalMs,
          );
          return;
        }
        if (result.status === "E") {
          downloadExportFile(taskSeq);
          return;
        }
        if (result.status === "X") {
          closeExportingFlow();
          AlertService.ok("ERROR", result.memo || t("inventoryExport.failed"));
          return;
        }
        exportPollingRef.current = setTimeout(
          () => pollExportStatus(taskSeq, pollingConfig, retry + 1),
          pollingConfig.intervalMs,
        );
      })
      .catch(() => {
        closeExportingFlow();
        AlertService.ok("ERROR", t("inventoryExport.statusError"));
      });
  };

  //匯出清冊
  const exportItem = (rowData, templateType) => {
    let keepLoadingForPolling = false;
    checkLoading(loading);
    const reqBody = {
      planSn: itemObj?.planSn,
      reportSeq: rowData?.reportSeq,
      isByReport: "Y",
      class: itemObj?.criterion === "0" ? "S" : itemObj?.criterion === "9" ? "G" : "C",
      templateType,
    };
    switch (templateType) {
      case "template1":
      case "template2":
      case "template3":
      case "template4":
        break;
      case "template5":
        reqBody.type = itemObj?.planType;
        break;
      case "template5_import":
        reqBody.type = `${itemObj?.planType}_import`;
        break;
      default:
        AlertService.ok("ERROR", t("inventoryExport.unknownTemplate"));
        checkLoading(loading, false);
        return;
    }

    createInventoryExportTask(reqBody)
      .then((res) => {
        if (!checkDpSuccess(res)) return;
        const taskSeq = res?.data?.RespBody?.taskSeq;
        if (!taskSeq) {
          AlertService.ok("ERROR", t("inventoryExport.createError"));
          return;
        }
        const pollingConfig = resolveExportPollingConfig(res?.data?.RespBody);
        keepLoadingForPolling = true;
        checkLoading(loading, true, t("inventoryExport.processing"));
        pollExportStatus(taskSeq, pollingConfig);
      })
      .finally(() => {
        if (!keepLoadingForPolling) {
          checkLoading(loading, false);
        }
      });
  };

  return (
    <>
      <div className="flex justify-content-between flex-wrap align-items-center">
        <div className="align-items-start">
          <Button
            rounded
            text
            onClick={() => {
              navigate("/management/carbonFootprint");
            }}
          >
            <FontAwesomeIcon icon="fa-solid fa-arrow-left-long" />
            {t("button.return_to_list")}
          </Button>
        </div>
        <div className="align-items-end">{/* 是否要顯示報表列表文字 */}</div>
      </div>
      <div className="grid">
        <div className="col-10">
          <Button
            loading={createLoading}
            disabled={createLoading || !isEditable}
            onClick={() => {
              axios_createESGReport();
            }}
          >
            {" "}
            {t("addReportFile")}
          </Button>
        </div>
        <div className="col-2 flex justify-content-end">
          <Button
            tooltip={t("inventoryPlanFlow.title")}
            tooltipOptions={{ position: "top" }}
            rounded
            text
            severity="secondary"
            className="p-button-icon-only"
            onClick={() => {
              setFlowModal(true);
            }}
          >
            <FontAwesomeIcon icon="fa-solid fa-compass" />
          </Button>
        </div>
      </div>

      {/* 報告書歷程記錄 */}
      <div className="p-card">
        <div className="p-card-body">
          {(itemObj?.companyName ?? companyName) && (
            <h3 className="text-center mt-0">{itemObj?.companyName ?? companyName}</h3>
          )}
          <DataTable
            stripedRows
            expandedRows={expandedRows}
            onRowToggle={(e) => {
              setExpandedRows(e.data);
            }}
            className="white-data-table hover-highlight no-shadow"
            tableStyle={{ minWidth: "55rem" }}
            value={rows}
            dataKey="reportSeq"
            rowExpansionTemplate={rowExpansionTemplate}
            footer={
              rows?.length > 0 && <PrimeTableFooter rowDataList={rows} isShowMore={true} btnReadMore={btnReadMore} />
            }
            emptyMessage={<NoInfo panel="table" />}
          >
            <Column expander={allowExpansion} style={{ width: "5rem" }} />
            <Column field="version1" header={t("versionNo")} />
            <Column field="createUserName" header={t("createUser")} />
            <Column field="createDate" header={t("createDate")} />
            <Column field="updateUserName" header={t("editUser")} />
            <Column field="updateDate" header={t("editDate")} />
            <Column field="memo" body={memoBodyTemplate} header={t("remark")} />
            <Column
              style={{ width: "auto" }}
              body={actionBodyTemplate}
              header={t("action")}
              frozen
              alignFrozen="right"
            />
          </DataTable>
        </div>
      </div>

      {/* 刪除 */}
      <PrimeConfirmDialog
        visible={delDialog}
        onClose={() => {
          setDelDialog(false);
        }}
        onConfirm={() => {
          confirmDel();
        }}
        title={t("button.delete")}
        bodyTemplate={delContent}
      />

      {/* 流程圖模態框 */}
      <ImageLocaleModal
        visible={flowModal}
        checked={flowCheck}
        onHide={() => setFlowModal(false)}
        onDontShowAgain={(dontShow) => {
          updateUserInfo(dontShow);
        }}
        step={flowStep}
      />

      {/* 重大性鑑別確認 */}
      <PrimeConfirmDialog
        visible={importantDialog}
        onClose={() => {
          setImportantDialog(false);
        }}
        onConfirm={() => {
          setImportantDialog(false);
          setTemplateDialog(true);
        }}
        title={t("hint")}
        bodyTemplate={t("cfm_plan_not_complete")}
      />

      {/* 匯出EXCEL清冊 */}
      <PrimeDialog
        size="sm"
        visible={templateDialog}
        onClose={() => {
          setTemplateDialog(false);
          setSelectedTemplate(null);
        }}
        onConfirm={() => {
          if (selectedTemplate) {
            exportItem(xlsxItemObj, selectedTemplate);
            setTemplateDialog(false);
            setSelectedTemplate(null);
          }
        }}
        title={t("選擇匯出的範本")}
        disabledConfirm={!selectedTemplate}
        bodyTemplate={
          itemObj?.planType === "0" || itemObj?.planType === "1"
            ? commonExportBodyTemplate()
            : industrialExportBodyTemplate(itemObj?.planTypeName)
        }
      />

    </>
  );
}
